// @tenorlab/vue-dashboard-pro
// file: src/async-widgets/widget-order-status/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { ShoppingBasket as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetOrderStatusMeta: TWidgetMetaInfo = {
  name: 'Order Status',
  categories: ['Chart'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Shows a chart of aggregated order statuses.',
  externalDependencies: [],
}
